import React from 'react';

interface HeaderProps {
  title: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {
  return (
    <div className="flex justify-between items-center mb-3 px-3 py-2 bg-white rounded-lg shadow">
      <h1 className="text-lg font-semibold text-black">{title}</h1>
    </div>
  );
};

export default Header;
